import { ShopUserType } from "./shop";

export enum AdminUserStatus {
  pending = "pending",
  created = "created",
}

export interface AdminUser {
  adminUserId: string;
  email: string;
  status: AdminUserStatus;
  type: ShopUserType;
  name: string;
}

export interface AdminUserFormData {
  email: string;
  name: string;
  type: ShopUserType;
}

export interface PosUser {
  id: string;
  name: string;
  email: string;
  mobileNumber: string;
}

export type RetailUserType = "retailManager" | "retailUser";

export interface PosUserFormData {
  adminUserIds: string[];
  type: RetailUserType;
}

export interface RetailUser {
  adminUserId: string;
  email: string;
  type: RetailUserType;
  createdAt: Date;
}

export type UserPreferenceType = "productFilter" | "orderFilter";

export interface UserPreference {
  id: string;
  shopId: string;
  userId: string;
  type: UserPreferenceType;
  preference: any;
  createdAt: Date;
}
